
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive/article/[...all]",
      function () {
        return require("private-next-pages/archive/article/[...all].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/archive/article/[...all]"])
      });
    }
  